
import React from "react";
import { useSelector } from "react-redux";
import SRList from "../component/List";
import Moment from "react-moment";
import AkkhorLayout from "../layout/Akkhor";

export default function ListTreeChuongTrinh() {
  let params = 'parent_id=0';
  const columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    { name: "title", label: "Tên cây kiến thức", options: { filter: true, sort: true } },
    {
      name: "datecreate", label: "Ngày tạo",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          const time = new Date(value * 1000);
          return <Moment format="HH:mm DD/MM/YYYY">{time}</Moment>;
        },
      }
    }
  ];


  return (
    <AkkhorLayout idrole="list-books-tree">
      <SRList name="books_tree" idrole="list-books-tree" params={params} title="Cây kiến thức" defaultLimit={50} serverSide={true} columns={columns}></SRList>
    </AkkhorLayout>
  );
}
